export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      noticeReadInfo: [
        {
          deviceSerial: "2020Nxxxxxx",
          locationNumber: "location-001",
          readAt: 1234567890123,
          thumbupAt: 1234567890123,
        },
        {
          deviceSerial: "2020Nxxxxxx",
          locationNumber: "location-002",
          readAt: 1234567890123,
          thumbupAt: null,
        }
      ]
    }
  }
}